import decodeJwt from 'jwt-decode';
import { LockeClientId } from '../types';
import { isLockeAuthenticated } from './authenticationService';

export const isTokenExpired = (exp: number): boolean => {
  return exp < Date.now() / 1000;
};

export const isUserSignedIn = async (
  token: string | undefined,
  lockeClientId: LockeClientId,
): Promise<boolean> => {
  if (token) {
    const { exp, locke_id } = decodeJwt(token) as {
      exp: number;
      locke_id: string;
    };
    if (locke_id && exp) {
      if (isTokenExpired(exp)) {
        return await isLockeAuthenticated(token, lockeClientId);
      }
      return true;
    }
  }
  return false;
};
